export interface AccountingDeductionSubTypeProps {
  deductionSubTypeId: number | null;
  deductionSubTypeKey: string;
  deductionSubTypeName: string;
}

export class AccountingDeductionSubType {
  private readonly _deductionSubTypeId: number | null;
  private readonly _deductionSubTypeKey: string;
  private readonly _deductionSubTypeName: string;

  constructor(props: AccountingDeductionSubTypeProps) {
    this._deductionSubTypeId = props.deductionSubTypeId ?? null;
    this._deductionSubTypeKey = props.deductionSubTypeKey;
    this._deductionSubTypeName = props.deductionSubTypeName;
  }

  public get deductionSubTypeId(): number | null {
    return this._deductionSubTypeId;
  }

  public get deductionSubTypeKey(): string {
    return this._deductionSubTypeKey;
  }

  public get deductionSubTypeName(): string {
    return this._deductionSubTypeName;
  }

  public static fromJson(props: AccountingDeductionSubTypeProps): AccountingDeductionSubType {
    return new AccountingDeductionSubType(props);
  }
}
